'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/6.
                                          */

// import { Section, Header } from 'react-fullpage';

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _reactRedux = require('react-redux');

var _serviceDetail = require('redux/modules/serviceDetail');

var _serviceOrderBuy = require('redux/modules/serviceOrderBuy');

var _reduxAsyncConnect = require('redux-async-connect');

var _background = require('redux/modules/background');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!(0, _serviceDetail.isLoaded)(getState())) {
      var promises = [];
      promises.push(dispatch((0, _serviceDetail.load)(params.type, params.serviceId)));
      promises.push(dispatch((0, _background.changeHeaderText)('服务主页')));
      return _promise2.default.all(promises);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.serviceDetail.data,
    designSubmitting: state.serviceDetail.designSubmitting,
    expressSubmitting: state.serviceDetail.expressSubmitting
  };
}, {
  routerPush: _reactRouterRedux.push,
  getServiceData: _serviceOrderBuy.load
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ServiceDetail, _Component);

  function ServiceDetail() {
    (0, _classCallCheck3.default)(this, ServiceDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ServiceDetail).call(this));

    _this.state = {
      headerActiveIndex: 0,
      termsModal: false,
      productsModal: false,
      productsSubmitModal: false,
      successModal: false,
      productsSelected: []
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceDetail, [{
    key: 'onTermsModalOpen',
    value: function onTermsModalOpen() {
      this.setState({
        termsModal: true
      });
    }
  }, {
    key: 'onTermsModalClose',
    value: function onTermsModalClose() {
      this.setState({
        termsModal: false
      });
    }
  }, {
    key: 'onTermsSubmit',
    value: function onTermsSubmit() {
      var _this2 = this;

      var _props = this.props;
      var dispatch = _props.dispatch;
      var servicesExpressDetailBuy = _props.data.servicesExpressDetailBuy;

      if (dispatch) {
        dispatch((0, _serviceDetail.expressTermsSubmit)({
          content: servicesExpressDetailBuy[0].content,
          shopId: servicesExpressDetailBuy[0].shopId
        })).then(function (nextData) {
          if (nextData.isValid) {
            _this2.setState({
              termsModal: false,
              successModal: true
            });
          }
        });
      }
    }
  }, {
    key: 'onProductsModalOpen',
    value: function onProductsModalOpen() {
      this.setState({
        productsModal: true
      });
    }
  }, {
    key: 'onServiceProductSubmit',
    value: function onServiceProductSubmit(serviceId) {
      var _props2 = this.props;
      var getServiceData = _props2.getServiceData;
      var routerPush = _props2.routerPush;

      if (getServiceData && routerPush) {
        getServiceData(serviceId).then(function (nextData) {
          // console.log(nextData);
          if (nextData && nextData.serviceOrderBuyInfo instanceof Array && nextData.serviceBuyClientInfo instanceof Array) {
            routerPush('/serviceorderbuy/' + serviceId);
          }
        });
      }
    }
  }, {
    key: 'onProductSelectChange',
    value: function onProductSelectChange(productInfo) {
      var dispatch = this.props.dispatch;

      if (dispatch) {
        dispatch((0, _serviceDetail.productSelectChange)(productInfo));
      }
    }
  }, {
    key: 'onProductsModalSubmit',
    value: function onProductsModalSubmit() {
      var servicesDesignDetailBuyDetail = this.props.data.servicesDesignDetailBuyDetail;

      var result = [];
      if (servicesDesignDetailBuyDetail instanceof Array) {
        servicesDesignDetailBuyDetail.forEach(function (info) {
          if (info.selected === '1') {
            result.push((0, _extends3.default)({}, info));
          }
        });
      }
      this.setState({
        productsModal: false,
        productsSubmitModal: result.length > 0,
        productsSelected: result
      });
    }
  }, {
    key: 'onProductsSubmit',
    value: function onProductsSubmit(data) {
      var _this3 = this;

      var _props3 = this.props;
      var dispatch = _props3.dispatch;
      var servicesDesignDetailBuy = _props3.data.servicesDesignDetailBuy;
      var productsSelected = this.state.productsSelected;

      var products = productsSelected.map(function (info) {
        return {
          productId: info.productId,
          productName: info.productName,
          productDescribe: info.productDescribe,
          productPrice: info.productPrice
        };
      });
      if (dispatch) {
        dispatch((0, _serviceDetail.productsSubmit)(products, (0, _extends3.default)({
          shopId: servicesDesignDetailBuy[0].shopId,
          shopContact: servicesDesignDetailBuy[0].shopContact,
          shopMobile: servicesDesignDetailBuy[0].shopMobile
        }, data))).then(function (nextData) {
          if (nextData.isValid) {
            _this3.setState({
              productsSubmitModal: false,
              successModal: true
            });
          }
        });
      }
    }
  }, {
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      this.setState({
        successModal: false
      });
    }
  }, {
    key: 'closeProductsModal',
    value: function closeProductsModal() {
      this.setState({
        productsModal: false
      });
    }
  }, {
    key: 'closeProductsSubmitModal',
    value: function closeProductsSubmitModal() {
      this.setState({
        productsSubmitModal: false
      });
    }
  }, {
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'analysisProductExpress',
    value: function analysisProductExpress() {
      var _state = this.state;
      var headerActiveIndex = _state.headerActiveIndex;
      var termsModal = _state.termsModal;
      var successModal = _state.successModal;
      var _props4 = this.props;
      var data = _props4.data;
      var expressSubmitting = _props4.expressSubmitting;

      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        var servicesExpressDetailHome = data.servicesExpressDetailHome;
        var servicesExpressDetailIntroduce = data.servicesExpressDetailIntroduce;
        var servicesExpressDetailAptitude = data.servicesExpressDetailAptitude;
        var servicesExpressDetailCulture = data.servicesExpressDetailCulture;
        var servicesExpressDetailCommunication = data.servicesExpressDetailCommunication;
        var servicesExpressDetailBuy = data.servicesExpressDetailBuy;

        var styles = require('./ServiceDetail.scss');
        var options = {
          sectionClassName: 'section',
          anchors: ['servicesExpressDetailHome', 'servicesExpressDetailIntroduce', 'servicesExpressDetailAptitude', 'servicesExpressDetailCulture', 'servicesExpressDetailCommunication'],
          scrollBar: false,
          activeClass: styles.active,
          navigation: false,
          verticalAlign: false,
          sectionPaddingTop: '0',
          sectionPaddingLeft: '0',
          sectionPaddingRight: '0',
          sectionPaddingBottom: '0'
        };
        var array = [{
          text: '首页',
          href: 'servicesExpressDetailHome',
          type: 'nav',
          index: 0,
          className: 'back1',
          icon: 'icon00'
        }, {
          text: '介绍',
          href: 'servicesExpressDetailIntroduce',
          type: 'nav',
          index: 1,
          className: 'back2',
          icon: 'icon16'
        }, {
          text: '资质',
          href: 'servicesExpressDetailAptitude',
          type: 'nav',
          index: 2,
          className: 'back3',
          icon: 'icon10'
        }, {
          text: '文化',
          href: 'servicesExpressDetailCulture',
          type: 'nav',
          index: 3,
          className: 'back4',
          icon: 'icon17'
        }, {
          text: '沟通',
          href: 'servicesExpressDetailCommunication',
          type: 'nav',
          index: 4,
          className: 'back5',
          icon: 'icon18'
        }];
        resultDiv = _react2.default.createElement(
          'div',
          { className: styles.component },
          _react2.default.createElement(
            'a',
            { onClick: this.onTermsModalOpen.bind(this), className: styles.buyBtn },
            _react2.default.createElement('div', { className: styles.traioef_an })
          ),
          _react2.default.createElement(
            _components.FullPageHeader,
            null,
            _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
          ),
          _react2.default.createElement(
            _components.FullPageSectionsContainer,
            (0, _extends3.default)({ activeChange: this.activeChange.bind(this),
              className: 'container' }, options),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '0', className: styles.goeasySection },
              headerActiveIndex === 0 ? _react2.default.createElement(
                'a',
                { href: '#serviceDetailIntroduce', className: styles.nextIcon },
                _react2.default.createElement('img', {
                  src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
              ) : '',
              _react2.default.createElement(
                'div',
                { className: styles.bbox },
                _react2.default.createElement(_Header2.default, null)
              ),
              servicesExpressDetailHome instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true, images: servicesExpressDetailHome }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '1', className: styles.goeasySection },
              servicesExpressDetailIntroduce instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesExpressDetailIntroduce }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '2', className: styles.goeasySection },
              servicesExpressDetailAptitude instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesExpressDetailAptitude }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '3', className: styles.goeasySection },
              servicesExpressDetailCulture instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesExpressDetailCulture }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '4', className: styles.goeasySection },
              servicesExpressDetailCommunication instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesExpressDetailCommunication }) : ''
            )
          ),
          _react2.default.createElement(_components.ServiceDetailTermsModal, { data: servicesExpressDetailBuy,
            onClose: this.onTermsModalClose.bind(this),
            onSubmit: this.onTermsSubmit.bind(this),
            isOpened: termsModal }),
          _react2.default.createElement(_components.LoadModal, { isOpened: expressSubmitting }),
          _react2.default.createElement(_components.SuccessModal, { isOpened: successModal, onSubmit: this.onCloseSuccessModal.bind(this),
            width: '400', text: '购买成功' })
        );
      }
      return resultDiv;
    }
  }, {
    key: 'analysisProductDesign',
    value: function analysisProductDesign() {
      // const { headerActiveIndex, productsModal, productsSubmitModal, productsSelected, successModal} = this.state;
      var headerActiveIndex = this.state.headerActiveIndex;
      // const {data, designSubmitting} = this.props;

      var data = this.props.data;

      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        var servicesDesignDetailHome = data.servicesDesignDetailHome;
        var servicesDesignDetailIntroduce = data.servicesDesignDetailIntroduce;
        var servicesDesignDetailCases = data.servicesDesignDetailCases;
        var servicesDesignDetailTeam = data.servicesDesignDetailTeam;
        var servicesDesignDetailContactMan = data.servicesDesignDetailContactMan;
        var
        // servicesDesignDetailBuy,
        // servicesDesignDetailBuyDetail,
        servicesDesignDetailProducts = data.servicesDesignDetailProducts;

        var styles = require('./ServiceDetail.scss');
        var options = {
          sectionClassName: 'section',
          anchors: ['servicesDesignDetailHome', 'servicesDesignDetailIntroduce', 'servicesDesignDetailCases', 'servicesDesignDetailTeam', 'servicesDesignDetailContactMan', 'servicesDesignDetailProducts'],
          scrollBar: false,
          activeClass: styles.active,
          navigation: false,
          verticalAlign: false,
          sectionPaddingTop: '0',
          sectionPaddingLeft: '0',
          sectionPaddingRight: '0',
          sectionPaddingBottom: '0'
        };
        var array = [{
          text: '首页',
          href: 'servicesDesignDetailHome',
          type: 'nav',
          index: 0,
          className: 'back1',
          icon: 'icon01'
        }, {
          text: '介绍',
          href: 'servicesDesignDetailIntroduce',
          type: 'nav',
          index: 1,
          className: 'back2',
          icon: 'icon20'
        }, {
          text: '案例',
          href: 'servicesDesignDetailCases',
          type: 'nav',
          index: 2,
          className: 'back3',
          icon: 'icon17'
        }, {
          text: '团队',
          href: 'servicesDesignDetailTeam',
          type: 'nav',
          index: 3,
          className: 'back4',
          icon: 'icon18'
        }, {
          text: '联系',
          href: 'servicesDesignDetailContactMan',
          type: 'nav',
          index: 4,
          className: 'back5',
          icon: 'icon19'
        }, {
          text: '服务',
          href: 'servicesDesignDetailProducts',
          type: 'nav',
          index: 5,
          className: 'back6',
          icon: 'icon22'
        }];
        // onClick={this.onProductsModalOpen.bind(this)}
        resultDiv = _react2.default.createElement(
          'div',
          { className: styles.component },
          headerActiveIndex === 0 ? _react2.default.createElement(
            'a',
            { href: '#servicesDesignDetailIntroduce', className: styles.nextIcon },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
          ) : '',
          _react2.default.createElement(
            _components.FullPageHeader,
            null,
            _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
          ),
          _react2.default.createElement(
            _components.FullPageSectionsContainer,
            (0, _extends3.default)({ activeChange: this.activeChange.bind(this),
              className: 'container' }, options),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '0', className: styles.goeasySection },
              _react2.default.createElement(
                'div',
                { className: styles.header },
                _react2.default.createElement(_Header2.default, null)
              ),
              servicesDesignDetailHome instanceof Array ? _react2.default.createElement(
                'div',
                { className: styles.firstFullPageItem },
                _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true,
                  images: servicesDesignDetailHome })
              ) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '1', className: styles.goeasySection },
              servicesDesignDetailIntroduce instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesDesignDetailIntroduce }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '2', className: styles.goeasySection },
              servicesDesignDetailCases instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesDesignDetailCases }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '3', className: styles.goeasySection },
              servicesDesignDetailTeam instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesDesignDetailTeam }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '4', className: styles.goeasySection },
              servicesDesignDetailContactMan instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: servicesDesignDetailContactMan }) : ''
            ),
            _react2.default.createElement(
              _components.FullPageSection,
              { key: '5', className: styles.goeasySection },
              servicesDesignDetailProducts instanceof Array ? _react2.default.createElement(_components.CarouselTextOfDetail, { data: servicesDesignDetailProducts,
                onBtnClick: this.onServiceProductSubmit.bind(this),
                page: 'serviceDetail' }) : ''
            )
          )
        );
      }
      return resultDiv;
    }
  }, {
    key: 'render',
    value: function render() {
      var params = this.props.params;

      var result = _react2.default.createElement('div', null);
      if (params.type) {
        result = this.analysisProductDesign();
      } else {
        result = this.analysisProductExpress();
      }
      return result;
    }
  }]);
  return ServiceDetail;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  dispatch: _react.PropTypes.func,
  params: _react.PropTypes.object,
  designSubmitting: _react.PropTypes.bool,
  expressSubmitting: _react.PropTypes.bool,
  routerPush: _react.PropTypes.func,
  getServiceData: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ServiceDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ServiceDetail/ServiceDetail.js
 ** module id = 1532
 ** module chunks = 0
 **/